export default () => {
    const nodeSelectors = {
        container: '[js-amenities-map="container"]',
        map: '[js-amenities-map="map"]',
    }

    const parent = document.querySelector(nodeSelectors.container);
    const child = document.querySelector(nodeSelectors.map);

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        window.addEventListener("load", function () {
            centerContainer()
        });

        window.addEventListener("resize", function () {
            centerContainer()
        });
    }

    function centerContainer() {
        const scrollLeft = (child.offsetWidth - parent.clientWidth) / 2;
        // const scrollTop = (child.offsetHeight - parent.clientHeight) / 2;
        parent.scrollLeft = scrollLeft + 45;
        // parent.scrollTop = scrollTop;
    }

    function centerContainerByChild(element) {
        if (!element) return;
        const scrollLeft = element.offsetLeft - parent.clientWidth / 2 + element.clientWidth / 2;
        // const scrollTop = element.offsetTop - parent.clientHeight / 2 + element.clientHeight / 2;

        parent.scrollLeft = scrollLeft;
        // parent.scrollTop = scrollTop;
    }

    return Object.freeze({
        nodeSelectors,
        init,
        centerContainerByChild
    })
}